module.exports = __webpack_public_path__ + "static/checkout-3fa9094b417f01e781d4508739b2e3e9.png";